import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const ProductsProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `Products/${props.productId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `Products`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `Products/${props.productId}`, method: 'PUT', payload: props, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async () => {
        await execute({ scope: 'list', url: `Products`, method: 'GET', secure: true });
    }, [execute]);

    const listFranchiseProductRecords = useCallback(async (props) => {
        await execute({ scope: 'list_franchise_products', url: `Products/FranchiseAvailable/${props.franchiseId}`, method: 'GET', secure: true });
    }, [execute]); 

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `Products/${props.productId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const value = { selectRecord, listRecords, listFranchiseProductRecords, newRecord, deleteRecord, updateRecord, createRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useProductsStore = () => React.useContext(Context);
